<template>
  <div class="wrap">
    <van-sticky>
      <van-nav-bar @click-left="onClickLeft" left-arrow :safe-area-inset-top="true" :title="baseFormVO.baseForm.name" />
    </van-sticky>
    <div class="pl40 pr40" style="padding-bottom: 88px;">
      <div class="block">
        <!-- 表单组成 -->
        <Form ref="Form" :month="month" :sex="sex" :disabled="disabled" :fields="baseFormVO.fields" :title="baseFormVO.baseForm.name" :optionalFlag="baseFormVO.baseForm.optionalFlag" />
      </div>
    </div>
    <!-- 按钮 -->
    <div class="footer flex-row-between">
      <van-button @click="indexChange(-1)" round block type="primary" native-type="submit" color="#ff9e19">
      上一步
      </van-button>
      <van-button v-if="baseFormIndex < (formList.length - 1)" @click="indexChange(1)" round block type="primary" native-type="submit" color="#ff9e19" :plain="!baseFormVO.baseForm.optionalFlag">
      下一步
      </van-button>
      <van-button v-if="baseFormIndex == (formList.length - 1)" @click="indexChange(0)" round block type="primary" native-type="submit" color="#ff9e19" :plain="!baseFormVO.baseForm.optionalFlag">
      提交并查看报告
      </van-button>
    </div>
  </div>
</template>
<script>
import { detail } from '../../../../api/testing'
import { preview } from '../../../../api/form'
import { fetchFieldsRecord, submitForm } from '../../../../api/form-record'
import { submit as submitTesting } from '../../../../api/testing-record'
import Form from '@/components/Form'
import { dealCondition } from '@/utils/tools'
import { Toast } from 'vant'
export default {
  data() {
    return {
      showLoading: true,
      month: '',
      sex: '',
      disabled: false,
      formList: [],
      baseFormRecordIdJson: {},
      baseFormRecordId: null,
      baseFormId: null,
      baseFormIndex: 0,
      baseFormVO: {
        baseForm: {}
      },
      testingVO: {},
      testingId: null,
      testingRecordId: null
    }
  },
  components: {
    Form
  },
  created() {
    this.init()
  },
  watch: {
    $route() {
      this.init()
    }
  },
  methods: {
    onClickLeft() {
      history.back()
    },
    async init() {
      if (this.$route.query.month) {
        this.month = parseInt(this.$route.query.month)
      }
      if (this.$route.query.sex) {
        this.sex = this.$route.query.sex
      }
      if (this.$route.query.disabled == 'true') {
        this.disabled = true
      }
      if (localStorage.getItem('disabled') && localStorage.getItem('disabled') == 'true') {
        this.disabled = true
      }
      this.testingId = this.$route.query.testingId
      this.testingRecordId = this.$route.query.testingRecordId
      // 加载分析
      await detail({
        testingRecordId: this.testingRecordId,
        testingId: this.testingId
      }).then(res => {
        var baseFormIds = []
        this.testingVO = res
        // 根据月份处理表单，处理一遍表单
        res.baseForms.forEach(it => {
          if (dealCondition(it.condition, this.month)) {
            baseFormIds.push(it.id)
          }
        })
        this.formList = baseFormIds
        // 默认从第一个开始
        this.baseFormId = res.baseFormIds[0]
        this.baseFormIndex = 0
        this.dealFormAndRecord()
      })
    },
    dealFormAndRecord() {
      // 处理表单，和表单记录
      preview({
        baseFormId: this.baseFormId
      }).then(res => {
        // 处理记录
        res.fields.forEach(it => {
          if (it.data) {
            var data = []
            it.data.forEach(option => {
              if (dealCondition(option.condition, this.month)) {
                data.push(option)
              }
            })
            it.data = data
          }
        })
        this.baseFormVO = res
        // 加载记录
        fetchFieldsRecord({
          baseFormId: this.baseFormId,
          testingRecordId: this.testingRecordId
        }).then(data => {
          // this.baseFormRecordIdJson[this.baseFormVO.code] = data.baseFormRecordId
          this.baseFormRecordId = data.baseFormRecordId
          this.$refs['Form'].resetData(data.fieldsData)
        })
      })
    },
    async indexChange(step) {
      if (this.disabled) {
        if (step == 0) {
          Toast.loading({
            duration: 0,
            message: '加载中...',
            forbidClick: true,
          })
          submitTesting({
            testingRecordId: this.testingRecordId
          }).then(res => {
            Toast.clear()
            if (res == 'free') {
              // 查看体验结果
              this.$router.push({
                path: "/free-report",
                query: {
                  testingRecordId: this.testingRecordId
                },
              })
            } else {
              if (res) {
                this.baseFormIndex += step
                this.baseFormId = this.formList[this.baseFormIndex]
                Toast.clear()
                this.$router.push({
                  path: "/show-report",
                  query: {
                    url: res
                  },
                })
              } else {
                Toast('报告不存在')
              }
            }
          })
        }
        this.baseFormIndex += step
        this.baseFormId = this.formList[this.baseFormIndex]
        this.dealFormAndRecord()
        return false
      }
      if (step == -1) {
        if (this.baseFormIndex == 0) {
          this.$router.go(-1);
          return false
        }
        this.baseFormIndex += step
        this.baseFormId = this.formList[this.baseFormIndex]
        this.dealFormAndRecord()
      }
      if (step == 1 || step == 0) {
        await this.$refs['Form'].doSave().then(res => {
          // 提交表单
          Toast.loading({
            duration: 0,
            message: '加载中...',
            forbidClick: true,
          })
          submitForm({
            baseFormRecordId: this.baseFormRecordId,
            fields: res
          }).then(ress => {
            Toast.clear()
            this.baseFormIndex += step
            this.baseFormId = this.formList[this.baseFormIndex]
            if (step == 1) {
              this.dealFormAndRecord()
            }
            if (step == 0) {
              this.dealReport()
            }
          })
        })
      }
    },
    dealReport() {
      // 查看报告
      submitTesting({
        testingRecordId: this.testingRecordId
      }).then(res => {
        if (res) {
          if (res == 'free') {
            // 查看体验结果
            this.$router.push({
              path: "/free-report",
              query: {
                testingRecordId: this.testingRecordId
              },
            })
            return false
          }
          localStorage.setItem('disabled', 'true')
          setTimeout(() => {
            this.$router.push({
              path: "/show-report",
              query: {
                url: res
              },
            })
          }, 300)
        } else {
          Toast('报告生成失败')
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
@import url('../../../../assets/css/style.css');
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px 40px;
  background: #fff;
  .van-button {
    width: 45%;
  }
}
.block {
  border-radius: 16px;
  margin-top: 40px;
  padding: 0 24px 40px 24px;
  background: #fff;
}
.testing {
  padding: 0 40px;
  margin-top: 24px;
  border-radius: 24px;
  background: #fff;
  height: 160px;
  .go {
    background: #ff9e19;
    color: #fff;
    font-size: 0.32rem;
    height: 48px;
    width: 120px;
    text-align: center;
    line-height: 50px;
    border-radius: 16px;
  }
}
</style>